import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ErrorBoundary from 'components/ErrorBondries';

ReactDOM.render(
  // <React.StrictMode>
  <>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
    </>,
  // </React.StrictMode>,
  document.getElementById('root')
);
